import i18n from '@/i18n';

const meta = {
  loadState: true,
  auth: true,
  isAuthPage: false,
  permissions: [
    {
      subject: 'loyalty_program',
      actions: ['list-all'],
    }
  ],
  title: i18n.global.t('creator_program')
}

export default [
  {
    path: '/creator-program',
    name: 'creator-program',
    component: () => import('../../views/Proxy.vue'),
    meta,
    children: [
      {
        path: 'businesses',
        name: 'creator-program-businesses',
        meta: { ...meta, title: i18n.global.t('creator_program_businesses') },
        component: () => import('../../views/creatorProgram/Businesses.vue'),
        children: [
          {
            path: 'new',
            name: 'creator-program-businesses-new',
            meta: { ...meta, title: i18n.global.t('new_creator_program_business') },
            component: () => import('../../views/creatorProgram/Business.vue'),
          },
          {
            path: ':id(\\d+)',
            name: 'creator-program-businesses-details',
            meta: { ...meta, title: i18n.global.t('creator_program_business_details') },
            component: () => import('../../views/creatorProgram/Business.vue'),
          },
        ]
      },
      {
        path: 'billing-accounts',
        name: 'creator-program-billing-accounts',
        meta: { ...meta, title: i18n.global.t('creator_program_billing_accounts') },
        component: () => import('../../views/creatorProgram/Billing.vue'),
        children: [
          {
            path: 'new',
            name: 'creator-program-billing-accounts-new',
            meta: { ...meta, title: i18n.global.t('new_creator_program_billing_account') },
            component: () => import('../../views/creatorProgram/BillingAccount.vue'),
          },
          {
            path: ':id(\\d+)',
            name: 'creator-program-billing-accounts-details',
            meta: { ...meta, title: i18n.global.t('creator_program_billing_account_details') },
            component: () => import('../../views/creatorProgram/BillingAccount.vue'),
          },
        ]
      },
      {
        path: 'invoices',
        name: 'creator-program-invoices',
        meta: { ...meta, title: i18n.global.t('creator_program_invoices') },
        component: () => import('../../views/creatorProgram/Invoices.vue'),
        children: [
          {
            path: ':id(\\d+)',
            name: 'creator-program-invoices-details',
            meta: { ...meta, title: i18n.global.t('creator_program_invoice_details') },
            component: () => import('../../views/creatorProgram/Invoice.vue'),
          },
        ]
      },
    ]
  },
];
